import { SpecializationsSearch } from 'widgets/specializationsSearch';
import { SpecializationsList } from 'entities/specializations';
import styles from './styles.module.scss';
import { ChangeEvent, useState } from 'react';
import { useDebounceCallback } from 'shared/lib/debounce';

export const Specializations = () => {
  const [query, setQuery] = useState<string>('');

  const onInput = (e: ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value)
  }
  const onInputDebounced = useDebounceCallback(onInput, 300);

	return (
		<div className={styles.page}>
			<SpecializationsSearch onInput={onInputDebounced} />
			<div className={styles['specializations-list']}>
				<SpecializationsList query={query} />
			</div>
		</div>
	);
};
